import React from 'react';
import { Card, Grid, Typography, useTheme } from '@mui/material';
import { UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur } from '@europrocurement/l2d-domain/openApi/ApiUtilisateur';
import { BooleanBadge } from '@europrocurement/flexy-components';
import { User } from '../../../types/type';

type UserSupportProps = {
    user: User;
    handlePatchData: (
        payload: UtilisateursUtilisateurUpdateUtilisateurUtilisateurPatchUtilisateur,
    ) => void;
};

export const UserSupport: React.FunctionComponent<UserSupportProps> = function ({
    user,
    handlePatchData,
}) {
    const theme = useTheme();

    return (
        <Card
            sx={{
                width: '100%',
                margin: '15px 0',
                padding: '15px',
                backgroundColor: theme.palette.background.paper,
            }}
        >
            <Typography
                variant="l2dh6"
                sx={{
                    borderLeft: 2,
                    borderColor: theme.palette.primary.main,
                    padding: '5px 0 5px 30px',
                    marginLeft: '-15px',
                }}
            >
                Support en ligne
            </Typography>

            <Grid
                sx={{
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '15px',
                    width: '100%',
                    margin: '10px',
                    alignItems: 'center',
                }}
            >
                <BooleanBadge
                    label="Accès à l'application support en ligne"
                    value={user.droitUtilisateur?.usdAppsSupport}
                    icon
                    toggleAction={() =>
                        handlePatchData({
                            droitUtilisateur: {
                                usdAppsSupport: !user.droitUtilisateur?.usdAppsSupport,
                            },
                        })
                    }
                />

                <BooleanBadge
                    label="Droit d'administration du support en ligne"
                    value={user.droitUtilisateur?.usdAppsSupportOption}
                    icon
                    toggleAction={() =>
                        handlePatchData({
                            droitUtilisateur: {
                                usdAppsSupportOption: !user.droitUtilisateur?.usdAppsSupportOption,
                            },
                        })
                    }
                />
            </Grid>
        </Card>
    );
};
